import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";

@Entity({one: "user", many: "users"})
export class User {

	@Field()
	public id: ID;

	@Field()
	public firstName: string;

	@Field()
	public lastName: string;

	@Field()
	public email: string;

	@Field()
	public lastLoginDate?: string;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/User.ts